import { SwatchesProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SwatchesProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SwatchesProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      props: {
        colors: [
          '#000',
          '#fff',
          'red',
          'cyan',
          'rgb(200, 100, 0)',
          'turquoise',
          'beige',
        ],
      },
    } as SwatchesProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
